$(document).ready(function() {
  let audio1, audio2, audio3;

  $('.audio_section .content .audio_part .left_icon').click(function() {
    const $this = $(this);
    if($this.hasClass('active')) {
      if(audio1) audio1.pause(); 
      if(audio2) audio2.pause();
      if(audio3) audio3.pause();
      $this.removeClass('active');

      // Show play icon and hide pause icon
      $this.find('.play_icon').show();
      $this.find('.stop_icon').hide();
    }
    else {
      // Initialize audio only when play is clicked
      if (!audio1) {
        audio1 = new Audio($('#clip-a').attr('src'));
        audio1.loop = false;
        audio1.addEventListener('ended', handleAudioEnd);
      }
      if (!audio2) {
        audio2 = new Audio($('#clip-b').attr('src'));
        audio2.loop = false;
        audio2.addEventListener('ended', handleAudioEnd);
      }
      if (!audio3) {
        audio3 = new Audio($('#clip-c').attr('src'));
        audio3.loop = false;
        audio3.addEventListener('ended', handleAudioEnd);
      }

      audio1.play(); 
      audio2.play();
      audio3.play();

      var val = $(".audio_section .content .audio_part input[type='range']").val();
      updateMuteSettings(val, audio1, audio2, audio3);
      
      $this.addClass('active');

      // Show pause icon and hide play icon
      $this.find('.play_icon').hide();
      $this.find('.stop_icon').show();
    }
  });

  $('.audio_section .content .audio_part .scroll_option ul li').click(function() {
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    var val = $(this).attr('data-val');
    $(".audio_section .content .audio_part input[type='range']").val(val);
    if (audio1 && audio2 && audio3) {
      updateMuteSettings(val, audio1, audio2, audio3);
    }
  });

  $(".audio_section .content .audio_part input[type='range']").change(function() {
    var val = $(this).val();
    if (audio1 && audio2 && audio3) {
      updateMuteSettings(val, audio1, audio2, audio3);
    }
  });

  function updateMuteSettings(val, audio1, audio2, audio3) {
    if(val == '0') {
      audio1.muted = true;
      audio2.muted = true;
      audio3.muted = false;
    }
    else if(val == '50') {
      audio1.muted = true;
      audio2.muted = false;
      audio3.muted = true;
    }
    else {
      audio1.muted = false;
      audio2.muted = true;
      audio3.muted = true;
    }
  }

  function handleAudioEnd() {
    const $leftIcon = $('.audio_section .content .audio_part .left_icon');
    $leftIcon.removeClass('active');

    // Show play icon and hide pause icon
    $leftIcon.find('.play_icon').show();
    $leftIcon.find('.stop_icon').hide();

    if(audio1) {
      audio1.pause();
      audio1.currentTime = 0;
    }
    if(audio2) {
      audio2.pause();
      audio2.currentTime = 0;
    }
    if(audio3) {
      audio3.pause();
      audio3.currentTime = 0;
    }
  }
});
